import { useCurrentUser } from '@mp/hooks';
import { axios } from '@src/utils/networkRequests';
import { useQuery } from '@tanstack/react-query';

export const useReferralToken = () => {
  const { isAgency } = useCurrentUser();

  const fetchReferralToken = async () => {
    const { data } = await axios.get(`/v3/professional/referral_token`);
    return data;
  };

  const { data, isLoading } = useQuery(['referralToken'], () => fetchReferralToken(), {
    retry: 3,
    enabled: !isAgency,
  });

  return { referralToken: data?.referral_token, isLoading };
};
